import { axiosApi } from 'shared/api/axios'
import { OrderEndpoint } from './constants'
import { UpdateOrderRequest } from '../model'

export const updateOrder = async ({
    counterpartyId,
    contactId,
    orderId,
}: UpdateOrderRequest) => {
    try {
        await axiosApi.patch(`${OrderEndpoint.order}${orderId}`, {
            counterparty_id: counterpartyId,
            contact_id: contactId ?? undefined,
        })
        return true
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка создания заказа')
    }
}
